"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MilitaryConnectCodeVerificationResponseScheme = exports.CorpMemberInquireInputScheme = exports.CorpOkResponseScheme = exports.CorpEmailVerificationResponseScheme = exports.CorpMemberInfoResponseScheme = void 0;
var zod_1 = require("zod");
/**
 * 기업 회원 조회 응답
 */
exports.CorpMemberInfoResponseScheme = zod_1.z.object({
    corpMember: zod_1.z
        .object({
        corpId: zod_1.z.number(),
        corpName: zod_1.z.string(),
        corpEmail: zod_1.z.string().nullish(),
        connectDatetime: zod_1.z.string().nullish(),
        // CONNECT: 연결, PAUSE: 일시정지, DISCONNECT: 해지, HOLD: 홀딩(휴직)
        corpMemberStatusCode: zod_1.z.enum(['CONNECT', 'PAUSE', 'DISCONNECT', 'HOLD']).nullish(),
        holdStartDatetime: zod_1.z.string().nullish(),
        holdEndDatetime: zod_1.z.string().nullish(),
        statusChangeReason: zod_1.z.string().nullish(), // 상태 변경 사유
    })
        .nullish(),
});
/**
 * 이메일 유효성 체크 및 연결 가능한 기업 목록 조회
 */
exports.CorpEmailVerificationResponseScheme = zod_1.z.object({
    /**
     * VALID: 연결 가능
     * ALREADY_CONNECTED: 이미 연결된 기업이 있음
     * ALREADY_EXIST_MEMBER_EMAIL: 이메일로 가입한 다른 회원이 있음
     * NOT_FOUND_CORP: 제휴 기업이 없음
     */
    resultCode: zod_1.z.enum(['VALID', 'ALREADY_CONNECTED', 'ALREADY_EXIST_MEMBER_EMAIL', 'NOT_FOUND_CORP']).nullish(),
    corps: zod_1.z
        .array(zod_1.z.object({
        corpId: zod_1.z.number(),
        corpName: zod_1.z.string(), // 기업명
    }))
        .nullish(),
});
exports.CorpOkResponseScheme = zod_1.z
    .object({
    // 예외 발생시 응답
    error: zod_1.z
        .object({
        code: zod_1.z.string(),
        message: zod_1.z.string().nullish(),
    })
        .nullish(),
})
    .or(zod_1.z.string())
    .nullish();
exports.CorpMemberInquireInputScheme = zod_1.z.object({
    corpName: zod_1.z.string(),
    managerName: zod_1.z
        .string()
        .min(1, '이름을 입력해 주세요.')
        .max(12, '12자 이내로 입력해 주세요.')
        .regex(/^\S+$/, '띄어쓰기 없이 입력해 주세요.'),
    managerPhone: zod_1.z
        .string()
        .min(1, '전화번호를 입력해 주세요.')
        .regex(/^010[0-9]{7,8}$/, '유효한 전화번호를 입력해주세요.'),
    managerEmail: zod_1.z.string(),
});
exports.MilitaryConnectCodeVerificationResponseScheme = zod_1.z.object({
    /** 검증 결과에 대한 상세 메시지 */
    message: zod_1.z.string(),
    /**
     * 검증 결과 코드
     * VALID: 연결 가능
     * INVALID_CONNECT_CODE: 유효하지 않은 난수코드
     * ALREADY_USED_CONNECT_CODE: 이메일로 가입한 다른 회원이 있음
     * NOT_FOUND_CORP: 제휴 기업이 없음
     */
    resultCode: zod_1.z.enum(['VALID', 'INVALID_CONNECT_CODE', 'ALREADY_USED_CONNECT_CODE', 'NOT_FOUND_CORP']),
});
